<template>
  <div v-if="authenticate">
    <LogIn
      v-if="activeComponent === 'login'"
      :closeAuth="closeAuthDialog"
      :outsideClick="outsideClick"
      :toAuthRoute="to"
    />
    <ResetPasswordDialog
      :closeAuth="closeAuthDialog"
      :outsideClick="outsideClick"
      :show="activeComponent === 'reset'"
      :to="to"
    />
    <ResetPasswordRequestDialog
      :closeAuth="closeAuthDialog"
      :outsideClick="outsideClick"
      :show="activeComponent === 'request'"
      :to="to"
    />
    <SignUp
      v-if="activeComponent === 'signup'"
      :closeAuth="closeAuthDialog"
      :fromLogin="fromLogin"
      :outsideClick="outsideClick"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import LogIn from "@/components/Auth/LogIn/index.vue";
import ResetPasswordDialog from "@/components/Auth/ResetPassword/Dialog.vue";
import ResetPasswordRequestDialog from "@/components/Auth/ResetPasswordRequest/Dialog.vue";
import SignUp from "@/components/Auth/SignUp/index.vue";

export default {
  name: "Auth",
  components: {
    LogIn,
    ResetPasswordDialog,
    ResetPasswordRequestDialog,
    SignUp,
  },
  computed: {
    ...mapState({
      authenticate: (state) => state.auth.authenticate,
      activeComponent: (state) => state.auth.activeComponent,
    }),
  },
  created() {
    if (this.$route.params.token) {
      this.$store.commit("auth/SET_ACTIVE_COMPONENT", "reset");
    }
  },
  data() {
    return {
      fromLogin: null,
    };
  },
  methods: {
    closeAuthDialog() {
      this.$store.commit("auth/OPEN", false);
      this.$store.commit("auth/SET_ACTIVE_COMPONENT", "login");
    },
    outsideClick(val) {
      if (val) {
        return;
      }
      this.$store.commit("auth/OPEN", false);
      this.$store.commit("auth/SET_ACTIVE_COMPONENT", "login");
    },
    to(component, fromLogin) {
      this.$store.commit("auth/SET_ACTIVE_COMPONENT", component);
      this.fromLogin = fromLogin;
    },
  },
};
</script>
